import { writable } from "svelte/store";

export const searchTerm = writable("");